import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    // component: Home
  },
  // 联合会员---购买页
  {
    path: '/unionvip',
    name: 'unionvip',
    meta: {
      title: "中国体育+央视体育VIP联合会员"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/unionvip/index.vue')
  },
  // 联合会员---购买记录
  {
    path: '/unionrecord',
    name: 'unionrecord',
    meta: {
      title: "联合会员购买记录"
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/unionrecord/index.vue')
  },
  // 中国体育超级会员权益
  {
    path: '/vipRights',
    name: 'vipRights',
    meta: {
      title: "中国体育超级会员权益"
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/vipRights/index.vue')
  },
  // 会员兑换
  {
    path: '/vipexchange',
    name: 'vipexchange',
    meta: {
      title: "会员兑换码"
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/vipexchange/index.vue')
  },
  // 活动规则
  {
    path: '/activityRule',
    name: 'activityRule',
    meta: {
      title: "活动规则"
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/activityRule/index.vue')
  },
  // 央视体育vip服务协议
  {
    path: '/cctvRights',
    name: 'cctvRights',
    meta: {
      title: "央视体育vip服务协议"
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/cctvRights/index.vue')
  },
  // 中国体育下载页
  {
    path:'/down',
    name:'down',
    meta:{
      title:'「中国体育」zhibo.tv官方APP下载',
    },
    component: () => import( /* webpackChunkName: "about" */ '../views/livedown/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: 'unitevip',
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) { //如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
  next()
})
export default router